var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Box",
    [
      _c(
        "Box",
        {
          staticClass: "max-width",
          attrs: { display: "flex", flexAlign: "start" }
        },
        [
          _vm.showSidebar
            ? _c(
                "Card",
                { staticClass: "sidebar", attrs: { flex: 1, marginRight: 5 } },
                [
                  _c(
                    "FormSection",
                    [
                      _c(
                        "template",
                        { slot: "header" },
                        [
                          _c(
                            "Box",
                            { attrs: { display: "flex", flexAlign: "center" } },
                            [
                              _vm._v(" Payments "),
                              !_vm.fullyPaid && !_vm.uncollectible
                                ? _c(
                                    "UIButton",
                                    {
                                      staticClass: "add-btn smaller inverted",
                                      on: {
                                        click: function($event) {
                                          _vm.addNewPayment = true
                                        }
                                      }
                                    },
                                    [_vm._v("Add New Payment")]
                                  )
                                : _vm._e(),
                              !_vm.fullyPaid && _vm.uncollectible
                                ? _c(
                                    "UIButton",
                                    {
                                      staticClass:
                                        "add-btn smaller inverted red"
                                    },
                                    [_vm._v("Uncollectible pledge")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("template", { slot: "main" }, [
                        _c(
                          "ul",
                          { staticClass: "history-list" },
                          _vm._l(_vm.payments, function(payment) {
                            return _c(
                              "RouterLink",
                              {
                                key: payment.id,
                                attrs: {
                                  tag: "li",
                                  to: `${_vm.baseUrl}/${payment.id}`
                                }
                              },
                              [
                                _c(
                                  "layoutText",
                                  {
                                    staticClass: "history-amount",
                                    attrs: { fontSize: 1 }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatMoney(payment.amount)
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                _c(
                                  "layoutText",
                                  {
                                    staticClass: "history-date",
                                    attrs: { fontSize: 1 }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(payment.date.month) +
                                        "/" +
                                        _vm._s(payment.date.day) +
                                        "/" +
                                        _vm._s(payment.date.year)
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          }),
                          1
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "Box",
            { attrs: { flex: 3 } },
            [
              !_vm.payments.length && _vm.uncollectible
                ? _c("Card", [
                    _vm._v(
                      " Unable to add new payment. The pledge is uncollectible. "
                    )
                  ])
                : _vm._e(),
              (_vm.addNewPayment || !_vm.payments.length) && !_vm.uncollectible
                ? _c(
                    "PaymentForm",
                    _vm._b(
                      {
                        attrs: { pledgeCurrency: _vm.pledgeCurrency },
                        on: { submitted: _vm.toggleEditForm }
                      },
                      "PaymentForm",
                      _vm.paymentFormProps,
                      false
                    )
                  )
                : _c("Route", {
                    attrs: { path: `${_vm.baseUrl}/:id` },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ id }) {
                          return [
                            _vm.isPaymentExist(id)
                              ? _c("EditPaymentForm", {
                                  attrs: {
                                    paymentId: id,
                                    pledgeCurrency: _vm.pledgeCurrency,
                                    showAudit: false
                                  },
                                  on: {
                                    updated: _vm.toggleEditForm,
                                    deleted: _vm.toggleEditForm
                                  }
                                })
                              : _c("Redirect", {
                                  attrs: { to: `${_vm.baseUrl}` }
                                })
                          ]
                        }
                      }
                    ])
                  })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }